import { render, staticRenderFns } from "./basket-aside.vue?vue&type=template&id=41cdb5b4&"
import script from "./basket-aside.vue?vue&type=script&lang=js&"
export * from "./basket-aside.vue?vue&type=script&lang=js&"
import style0 from "./basket-aside.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports